import React from "react";
import CheckIcon from '@mui/icons-material/Check';
import PdfAttachment, { PdfPreviewFrame } from './PdfAttachment';
import { isPdfAttachment } from '../../utils/encodeImageFile';

class ReportNote extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showSavedIndicator: false
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.node.synced !== this.props.node.synced && this.props.node.synced) {
      this.setState({ showSavedIndicator: true });
      setTimeout(() => {
        this.setState({ showSavedIndicator: false });
      }, 2000);
    }
  }

  renderNodeContainer(children) {
    return (
      <div className="node-container" onClick={() => this.props.handleClick?.()}>
        {children}
      </div>
    );
  }

  renderNote() {
    const content = this.props.node.content?.length > 0 
      ? this.props.node.content 
      : 'Empty note, click to edit';

    return (
      <div className="note-container">
        {/* <div className={`saving-flash ${!this.props. ? 'shown' : ''}`} /> */}

        <div className={`saved-indicator ${this.state.showSavedIndicator ? 'shown' : ''}`}>
          <CheckIcon style={{fontSize: 18}} />
        </div>

        <div className="report-note">
          {content}
        </div>
      </div>
    );
  }

  renderImage() {
    return (
      <div className="report-node image">
        {this.state.showSavedIndicator && (
          <div className="saved-indicator">
            Saved
          </div>
        )}

        {isPdfAttachment(this.props.node) ? (
          <>
            <PdfAttachment url={this.props.node.image} name={this.props.node.image_name} />
            <PdfPreviewFrame url={this.props.node.image} name={this.props.node.image_name} />
          </>
        ) : (
          <img
            className="note-image"
            src={this.props.node.image}
            alt={this.props.node.content}
          />
        )}
        <div className="note-content">{this.props.node.content}</div>
      </div>
    );
  }

  render() {
    if (this.props.node.deleted) {
      return null;
    }

    switch (this.props.node.iAm) {
      case 'note':
        return this.renderNodeContainer(this.renderNote());
      case 'image':
        return this.renderNodeContainer(this.renderImage());
      default:
        return null;
    }
  }
}

export default React.memo(ReportNote, (prevProps, nextProps) => {
  // Custom comparison to prevent unnecessary re-renders
  return (
    prevProps.node?.id === nextProps.node?.id &&
    prevProps.node?.content === nextProps.node?.content &&
    prevProps.node?.image === nextProps.node?.image &&
    prevProps.node?.synced === nextProps.node?.synced &&
    prevProps.synced === nextProps.synced &&
    prevProps.component?.id === nextProps.component?.id
  );
});